import Immerable from '@naruto/naruto-models/src/types/GeneralImmer';
import { RuleKeyType, Rule, ValidationResult, Summary } from './types';

// 定義所有規則名稱
export enum RULE_KEY {
  MIN_LENGTH = 'MIN_LENGTH',
  UPPERCASE = 'UPPERCASE',
  LOWERCASE = 'LOWERCASE',
  NUMBER = 'NUMBER',
  SPECIAL_CHAR = 'SPECIAL_CHAR'
}

// 特殊字元集合（可自行擴充）
export const SPECIAL_CHAR_SET = '!@#$%^&*(),.?":{}|<>';

// === 預設規則 ===
export const DEFAULT_RULES: Rule[] = [
  {
    key: RULE_KEY.MIN_LENGTH,
    validate: (password: string) => password.length >= 8
  },
  {
    key: RULE_KEY.UPPERCASE,
    validate: (password: string) => /[A-Z]/.test(password)
  },
  {
    key: RULE_KEY.LOWERCASE,
    validate: (password: string) => /[a-z]/.test(password)
  },
  {
    key: RULE_KEY.NUMBER,
    validate: (password: string) => /\d/.test(password)
  },
  {
    key: RULE_KEY.SPECIAL_CHAR,
    validate: (password: string) =>
      new RegExp(`[${SPECIAL_CHAR_SET.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}]`).test(password)
  }
];

class PasswordValidator extends Immerable {
  private rules: Rule[];

  constructor(customRules: Rule[] = DEFAULT_RULES) {
    super();
    // 用 slice 避免修改到 DEFAULT_RULES
    this.rules = [...customRules];
  }

  // 驗證密碼
  public validate(password: string): ValidationResult[] {
    return this.rules.map(rule => ({
      key: rule.key,
      passed: rule.validate(password)
    }));
  }

  // 新增規則
  public addRule(key: RuleKeyType, validateFn: (password: string) => boolean): void {
    this.rules.push({ key, validate: validateFn });
  }

  // 移除規則
  public removeRule(key: RuleKeyType): void {
    this.rules = this.rules.filter(rule => rule.key !== key);
  }

  // 摘要結果：通過/失敗規則清單
  public summary(password: string): Summary {
    const results = this.validate(password);
    return {
      passed: results.filter(r => r.passed).map(r => r.key),
      failed: results.filter(r => !r.passed).map(r => r.key)
    };
  }

  // 是否全部通過
  public isValid(password: string): boolean {
    return this.validate(password).every(r => r.passed);
  }
}

export default PasswordValidator;

// // === 使用範例 ===
// const validator = new PasswordValidator();

// console.log("測試密碼：Abc123!");
// console.log(validator.summary("Abc123!"));

// console.log("測試密碼：AAAbbb123!");
// console.log(validator.summary("AAAbbb123!"));

// console.log("是否全部通過：", validator.isValid("Abc123!"));  // false
// console.log("是否全部通過：", validator.isValid("Abc123!@")); // true
